const { Fragment, useEffect, useState, useRef } = wp.element;

import Settings from "./settings";
import { bluePlaylist } from "../../js/playlist";
import Style from "./Style";

const Edit = (props) => {
  const { attributes, setAttributes, clientId } = props;
  const { uniqueId, audios, theme } = attributes;
  const [player, setPlayer] = useState();
  const dom = useRef();
  setAttributes({ clientId });

  useEffect(() => {
    if (player) {
      player.destroy();
    }
    const pl = bluePlaylist(dom.current, {}, audios);
    setPlayer(pl);
  }, [audios]);

  useEffect(() => {
    setAttributes({ uniqueId: "h5ap" + clientId.substr(0, 8) });
  }, []);

  return (
    <Fragment>
      <Style {...props} />
      <Settings props={props} />
      <div id={uniqueId} className="h5ap_playlist">
        <div className={`bluePlaylist hextensive-${theme.toLowerCase()}`} ref={dom}>
          <audio></audio>
        </div>
      </div>

      {/* {isSelected && (
        <div id="h5apGutenMenu">
          <button onClick={handleAddItem}>{__("Add New Item", "h5ap")}</button>
        </div>
      )} */}
    </Fragment>
  );
};

export default Edit;
